var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  hexToBytes: () => hexToBytes
});
function hexToBytes(hex) {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i] = parseInt(hex.substring(i, i + 2), 16);
  }
  return bytes;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  hexToBytes
});
